import { render, staticRenderFns } from "./students.vue?vue&type=template&id=1eb52e02&"
import script from "./students.vue?vue&type=script&lang=js&"
export * from "./students.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports